$(document).ready(function () {
    let loadmoreButton = $('#cm-guide-loadmore');
    if (loadmoreButton) {
        let container = $('#cm-guide-container');
        let maxPages = loadmoreButton.data('max-pages');
        let ajaxUrl = `${location.protocol}//${location.hostname}${location.port ? ':' + location.port : ''}/wp-admin/admin-ajax.php`;
        let paged = 1;

        loadmoreButton.on('click', function () {
            loadmoreButton.addClass('loading-start').attr('disabled', 'disabled');
            paged++;
            $.ajax({
                url: ajaxUrl,
                type: 'POST',
                data: {
                    'action': 'load_cm_guide_posts',
                    'paged': paged,
                },
                success: function (data) {
                    container.append(data);
                    if (paged >= maxPages) loadmoreButton.addClass('d-none');
                    loadmoreButton.removeClass('loading-start').removeAttr('disabled');
                }
            });
        });
    }
});